import {useEffect, useState} from 'react';
import {useMutation} from 'react-query';
import {IGetPrimaryTermsResponse} from '../../models/registration.model';
import {GetPrimaryTerms} from '../../services/registration.service';
import AdditionalInfo from '../additionalInfo/additionalInfo';
import DrawerBody from '../requestSteps/drawerBody/drawerBody';
import {IFormInnerState} from '../requestSteps/form/IFormInnerState';
import BasicInformation from './basicInformation';
import LayoutWithoutDrawer from '../../layouts/LayoutWithoutDrawer';

export default function BasicInforContainer({
    setStep,
    referenceKey,
    back,
}: IFormInnerState) {
    const [innerState, setInnerState] = useState<
        'additionalInfo' | 'basickInfo'
    >();
    const [content, setContent] = useState<IGetPrimaryTermsResponse>();

    const {mutate: GetPrimaryTermsMutate, isLoading} = useMutation(
        GetPrimaryTerms,
        {
            onSuccess: (data: IGetPrimaryTermsResponse) => {
                setInnerState!('additionalInfo');
                setContent(data);
            },
        }
    );

    useEffect(() => {
        GetPrimaryTermsMutate({referenceKey: referenceKey!});
    }, []);
    const currentState = {
        additionalInfo: (
            <LayoutWithoutDrawer>
                <AdditionalInfo
                    referenceKey={referenceKey!}
                    setInnerState={setInnerState}
                    setStep={setStep}
                    content={content!}
                    primaryTermsServiceLoading={isLoading}
                />
                ,
            </LayoutWithoutDrawer>
        ),
        basickInfo: (
            <DrawerBody>
                <BasicInformation
                    setStep={setStep}
                    referenceKey={referenceKey!}
                    back={back}
                />
            </DrawerBody>
        ),
    };
    return <div>{currentState[innerState!]}</div>;
}
